import {PaymentsCart} from '@chekin/core';

function checkIfTotalAmountToPayZero(paymentsCart?: PaymentsCart) {
  const isTotalAmountNotZero = Boolean(
    parseFloat(paymentsCart?.total_amount_to_pay || '0'),
  );
  const isRetentionAmountNotZero = Boolean(
    parseFloat(paymentsCart?.retention_payments_total || '0'),
  );
  const isPreAuthAmountNotZero = Boolean(
    parseFloat(paymentsCart?.pre_auth_payments_total || '0'),
  );

  return !isTotalAmountNotZero && !isRetentionAmountNotZero && !isPreAuthAmountNotZero;
}

type GetTotalPayNowParams = {
  depositFee: number;
  amount?: string;
  outsidePaidAmount?: string | null;
  isBookingPaymentsActive?: boolean;
};

function getTotalPayNow({
  depositFee,
  amount,
  outsidePaidAmount,
  isBookingPaymentsActive,
}: GetTotalPayNowParams) {
  if (!amount && !outsidePaidAmount) {
    return 0;
  }
  const totalAmount = parseFloat(amount || '0') + depositFee;

  if (!isBookingPaymentsActive) {
    return totalAmount.toFixed(2);
  }

  const amountPaid = parseFloat(outsidePaidAmount || '0');
  const isInvalidAmountPaid = Number.isNaN(amountPaid);

  if (isInvalidAmountPaid) {
    return totalAmount.toFixed(2);
  }

  return (totalAmount - amountPaid).toFixed(2);
}

export {checkIfTotalAmountToPayZero, getTotalPayNow};
